import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _04cfce4d = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _500a8504 = () => interopDefault(import('../pages/auth/signin.vue' /* webpackChunkName: "pages/auth/signin" */))
const _26ddd818 = () => interopDefault(import('../pages/auth/signup.vue' /* webpackChunkName: "pages/auth/signup" */))
const _33cb25a7 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _0c8b82fb = () => interopDefault(import('../pages/_appid/index.vue' /* webpackChunkName: "pages/_appid/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _04cfce4d,
    name: "404"
  }, {
    path: "/auth/signin",
    component: _500a8504,
    name: "auth-signin"
  }, {
    path: "/auth/signup",
    component: _26ddd818,
    name: "auth-signup"
  }, {
    path: "/",
    component: _33cb25a7,
    name: "index"
  }, {
    path: "/:appid",
    component: _0c8b82fb,
    name: "appid"
  }, {
    path: "*",
    component: _04cfce4d,
    name: "custom"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
